import { ValidatorFn } from '@angular/forms';

export const emailsMatchValidator =
  (emailControlName: string): ValidatorFn =>
  (ctrl) => {
    const emailControl = ctrl.parent?.get(emailControlName);

    const matches = emailControl?.value && emailControl.value === ctrl?.value;
    return !matches ? { noMatch: { value: emailControl?.value } } : null;
};